import {
  Point,
  Texture,
} from 'pixi.js';
import Actor from './Actor';
import Rail from './Rail';
import vars from '../vars';

class SideRails extends Actor {
  constructor(parent) {
    super(parent);

    this.ref = new global.PIXI.projection.Container2d();

    const whiteTexture = new Texture(Texture.EMPTY.baseTexture);
    whiteTexture.orig.width = vars.layout.STAGE_WIDTH / 1;
    whiteTexture.orig.height = vars.layout.STAGE_HEIGHT * 2.5;
    whiteTexture.alpha = 0;
    this.sprite = new global.PIXI.projection.Sprite2d(whiteTexture);

    this.railLeft = new Rail(this.sprite, 'left');
    this.railRight = new Rail(this.sprite, 'right');

    this.ref.addChild(this.sprite);

    this.setPerspective();
    this.resize();

    this.parent.ref.addChild(this.ref);
  }

  resize() {
    this.sprite.anchor = new Point(0.5, 0.5);
    this.sprite.position.x = vars.layout.STAGE_WIDTH / 2;
    this.sprite.position.y = vars.layout.STAGE_HEIGHT / 2;
  }

  destroy() {
    this.railLeft.destroy();
    this.railRight.destroy();
    this.railLeft = null;
    this.railRight = null;
    this.ref.destroy({ children: true });
  }
}

export default SideRails;
